import { useState } from 'react';
import { caseCategories, personCategories } from '@/mocks/blackMaterial';
import Reveal from './Reveal';
import SectionHeading from './SectionHeading';

const MODES = [
  { key: 'person', label: '按人物', sub: '谁被起底' },
  { key: 'case', label: '按事件', sub: '哪类被扒' },
] as const;

export default function CategoryBrowse() {
  const [mode, setMode] = useState<'person' | 'case'>('person');
  const data = mode === 'person' ? personCategories : caseCategories;

  return (
    <section id="dangan" className="scroll-mt-28 mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-16">
      <Reveal>
        <div className="flex flex-col justify-between gap-4 md:flex-row md:items-end">
          <SectionHeading
            kicker="INDEX · 分类档案"
            title="人物 · 事件分类档案馆"
            desc="想找某条内幕，先按「人物是谁」或「事件属于哪类」定位。每个栏目都标注了累计条目与今日更新数。"
          />
          <div className="flex items-center gap-2 pb-1">
            {MODES.map((m) => (
              <button
                key={m.key}
                onClick={() => setMode(m.key)}
                className={`cursor-pointer rounded-md border px-4 py-2 text-sm transition ${
                  mode === m.key
                    ? 'border-[#262019] bg-[#262019] text-[#f5efe3]'
                    : 'border-[#d8cbb6] bg-white text-[#6b5f51] hover:border-[#c83424] hover:text-[#c83424]'
                }`}
              >
                {m.label}
                <span className={`ml-1.5 text-[11px] ${mode === m.key ? 'text-[#d8cbb6]' : 'text-[#9a8a75]'}`}>
                  {m.sub}
                </span>
              </button>
            ))}
          </div>
        </div>
      </Reveal>

      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {data.map((c, idx) => (
          <Reveal key={`${mode}-${c.id}`} delay={idx * 60}>
            <button className="group relative h-full w-full cursor-pointer overflow-hidden rounded-lg bg-white p-5 text-left ring-1 ring-[#e6dbc9] transition hover:-translate-y-1 hover:ring-[#c83424]">
              <span className="font-display inline-block text-[13px] font-black uppercase tracking-wide text-[#c9bdab]">
                {String(c.id).padStart(2, '0')}
              </span>
              <h3 className="mt-3 flex items-center gap-2 text-lg font-extrabold text-[#262019]">
                {c.label}
                <span className="rounded-full bg-[#f0e8d8] px-2 py-0.5 text-[11px] font-semibold text-[#6b5f51]">
                  {c.count} 条
                </span>
              </h3>
              <p className="mt-2 text-[13px] leading-5 text-[#6b5f51]">{c.desc}</p>
              <div className="mt-5 flex items-center justify-between border-t border-[#eadfd0] pt-3">
                <span className="flex items-center gap-1 text-[11px] font-semibold text-[#c83424]">
                  <i className="ri-arrow-up-line"></i>今日 +{c.today}
                </span>
                <i className="ri-arrow-right-up-line text-[#c9bdab] transition group-hover:text-[#c83424]"></i>
              </div>
            </button>
          </Reveal>
        ))}
      </div>
    </section>
  );
}